import SspForm from 'common/pages/ssp/SspForm.tsx'

export const SspFormAgency = (props: any) => <SspForm {...props} mode={props.mode} />